export function sendConfiguratorEvent(event, action, label = null) {
    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        event: event,
        eventCategory: "configurator",
        eventAction: action,
        eventLabel: label,
    });
}
